import { lodash } from '@tarslib/collection/lib/util';
import xml2json, { removeXmlUselessPrefixAndSuffix } from '@tarslib/utils/es/utils/xml2json';
import { normalizeStream, toStream } from '../utils/stream.js';
import { HeaderList, PropertyBase, Property } from '@tarslib/collection';
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toBuffer(data) {
  if (data === undefined) return undefined;
  if (Buffer.isBuffer(data)) {
    return data;
  }
  return Buffer.from(toText(data));
}
function toText(data) {
  if (data === undefined) return undefined;
  if (typeof data === 'string') {
    return data;
  }
  if (Buffer.isBuffer(data)) {
    return data.toString();
  }
  if (_typeof(data) === 'object') {
    return JSON.stringify(data);
  }
  return data && String(data);
}
function toJson(data, reviver, strict) {
  var _text;
  if (data === undefined) return undefined;
  var text;
  if (Buffer.isBuffer(data)) {
    text = data.toString();
  } else if (typeof data === 'string') {
    text = data;
  } else {
    return data;
  }
  // xml 转 json
  if ((_text = text) !== null && _text !== void 0 && _text.trim().startsWith('<')) {
    return xml2json(text);
  }
  if (text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      // 处理类 xml 数据
      text = removeXmlUselessPrefixAndSuffix(text);
      return xml2json(text);
    }
  }
}
var SocketResponse = /*#__PURE__*/function (_Property) {
  function SocketResponse(options) {
    var _this;
    _classCallCheck(this, SocketResponse);
    _this = _callSuper(this, SocketResponse, [options]);
    // 数据处理器处理前数据
    _defineProperty(_this, "type", 'socket');
    _this.update(options);
    return _this;
  }
  _inherits(SocketResponse, _Property);
  return _createClass(SocketResponse, [{
    key: "update",
    value: function update() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref.data,
        stream = _ref.stream,
        originalData = _ref.originalData,
        originalStream = _ref.originalStream,
        responseTime = _ref.responseTime,
        responseSize = _ref.responseSize;
      if (data) {
        this.data = data;
      } else if (stream) {
        this.data = normalizeStream(stream);
      }
      if (originalData) {
        this.originalData = originalData;
      } else if (originalStream) {
        this.originalData = normalizeStream(originalStream);
      } else if (this.data) {
        this.originalData = this.data;
      }
      if (!responseSize) {
        if (Buffer.isBuffer(this.originalData)) {
          responseSize = this.originalData.byteLength;
        } else if (typeof this.originalData === 'string') {
          responseSize = this.originalData.length;
        }
      }
      responseSize && (this.responseSize = responseSize);
      responseTime && (this.responseTime = responseTime);
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this.data = data;
    }
  }, {
    key: "setOriginalData",
    value: function setOriginalData(originalData) {
      this.originalData = originalData;
    }
  }, {
    key: "text",
    value: function text() {
      return toText(this.data);
    }
  }, {
    key: "json",
    value: function json(reviver, strict) {
      return toJson(this.data);
    }
  }, {
    key: "buffer",
    value: function buffer() {
      return toBuffer(this.data);
    }
  }, {
    key: "originalText",
    value: function originalText() {
      return toText(this.originalData || this.data);
    }
  }, {
    key: "originalJson",
    value: function originalJson(reviver, strict) {
      return toJson(this.originalData || this.data);
    }
  }, {
    key: "originalBuffer",
    value: function originalBuffer() {
      return toBuffer(this.originalData || this.data);
    }
  }, {
    key: "size",
    value: function size() {
      var _this$originalBuffer;
      return ((_this$originalBuffer = this.originalBuffer()) === null || _this$originalBuffer === void 0 ? void 0 : _this$originalBuffer.length) || 0;
    }
  }, {
    key: "headers",
    get: function get() {
      return new HeaderList(null, []);
    }

    // 解决默认 toJSON 方法 Buffer 数据默认序列化后性能低下问题
  }, {
    key: "toJSON",
    value: function toJSON() {
      var obj;
      var dataIsBuffer = Buffer.isBuffer(this.data);
      var originalDataIsBuffer = Buffer.isBuffer(this.originalData);
      // data 转成 base64 格式，提高性能
      var data;
      var originalData;
      if (dataIsBuffer) {
        data = this.data;
        delete this.data;
      }
      if (originalDataIsBuffer) {
        originalData = this.originalData;
        delete this.originalData;
      }
      obj = PropertyBase.toJSON(this);
      if (dataIsBuffer) {
        obj.stream = toStream(data);
        this.data = data;
      }
      if (originalDataIsBuffer) {
        // 如 originalData 和 data 相同，则无需保存
        if (data !== originalData) {
          obj.originalStream = toStream(originalData);
        }
        this.originalData = originalData;
      }
      return obj;
    }
  }, {
    key: "toFastJSON",
    value: function toFastJSON() {
      return this.toJSON();
    }
  }], [{
    key: "isSocketResponse",
    value: function isSocketResponse(obj) {
      return Boolean(obj) && (obj instanceof SocketResponse || lodash.inSuperChain(obj.constructor, '_postman_propertyName', SocketResponse._postman_propertyName));
    }
  }]);
}(Property);
_defineProperty(SocketResponse, "_postman_propertyName", 'SocketResponse');
export { SocketResponse as default };
